import { render, staticRenderFns } from "./token.vue?vue&type=template&id=2cc8d17e&scoped=true&"
import script from "./token.vue?vue&type=script&lang=ts&"
export * from "./token.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8d17e",
  null
  
)

export default component.exports